class QuantityCalculator extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      areaInput: ".text-input",
      quantityInput: "[data-quantity-input]",
      productDetails: "[data-product-details]",
      boxArea: ".box-area",
      productForm: "[data-product-form-regular]",
      price: ".custom-price [data-price]",
    };

    this.areaInput = this.querySelector(this.selectors.areaInput);
    this.areaInput.addEventListener("input", this.handleInput.bind(this));
    this.quantityInput = this.querySelector(this.selectors.quantityInput);
    this.boxArea = this.querySelector(this.selectors.boxArea);

    this.moneyFormat = JSON.parse(
      this.closest(".shopify-section").querySelector(
        "[data-section-type='static-product']"
      ).innerHTML
    ).settings.money_format;

    this.productAreaQuantityCalc =
      this.areaInput.dataset.productAreaQuantityCalc;

    document.addEventListener("quantity-updated", (e) => {
      const quantity = e.detail.quantity;
      const number = quantity * parseFloat(this.productAreaQuantityCalc);
      this.areaInput.value = number.toFixed(2);
      this.quantity = quantity;
      this.area = quantity * parseFloat(this.productAreaQuantityCalc);
      this.handleChangePlaceholderPosition(this.area.toFixed(3));
      this.updateFormQuantity(this.quantity);
      this.updateBoxArea();
      this.updatePrice();
    });

    this.querySelector(".input-suffix").style.webkitTransform =
      "translate3d(24px, -50%, 0px)";
  }

  updatePrice() {
    const price = this.closest(this.selectors.productDetails).querySelector(
      this.selectors.price
    ).dataset.priceValue;

    const newPrice = Shopify.formatMoney(
      price * this.quantity,
      this.moneyFormat
    );

    this.closest(this.selectors.productDetails)
      .querySelectorAll(this.selectors.price)
      .forEach((itm) => (itm.innerHTML = newPrice));
  }

  updateFormQuantity = (quantity) => {
    this.closest(this.selectors.productDetails)
      .querySelector(this.selectors.productForm)
      .querySelector('input[name="quantity"]').value = quantity;
  };

  updateBoxArea = () => {
    if (this.quantity == 1) {
      this.boxArea.innerHTML = this.boxArea.dataset.singleTemplate
        .replace("[[quantity]]", this.quantity)
        .replace("[[area]]", this.area.toFixed(2));
      return;
    }

    this.boxArea.innerHTML = this.boxArea.dataset.multipleTemplate
      .replace("[[quantity]]", this.quantity)
      .replace("[[area]]", this.area.toFixed(2));
  };

  handleInput(event) {
    const value = parseFloat(event.target.value).toFixed(3);
    this.quantity = Math.ceil(value / parseFloat(this.productAreaQuantityCalc));

    this.quantityInput.value = this.quantity;
    // this.quantityInput.dispatchEvent(new Event("change"));
    this.area = value;
    this.handleChangePlaceholderPosition(value);
    this.updateFormQuantity(this.quantity);
    this.updateBoxArea();
    this.updatePrice();
  }

  handleChangePlaceholderPosition(value) {
    console.log("updating placeholder positoin", value);
    var i = "".concat(value).length + 1;
    this.querySelector(".input-suffix").style.webkitTransform =
      i <= 3
        ? "translate3d(0px, -50%, 0px)"
        : "translate3d(".concat(8 * (i - 2), "px, -50%, 0px)");
  }
}

customElements.define("quantity-calculator", QuantityCalculator);
